/** Storage provider type for media file persistence */
export var StorageProvider;
(function (StorageProvider) {
    StorageProvider["LOCAL"] = "LOCAL";
    StorageProvider["S3"] = "S3";
    StorageProvider["OSS"] = "OSS";
})(StorageProvider || (StorageProvider = {}));
/** Media file type classification */
export var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["DOCUMENT"] = "DOCUMENT";
})(MediaType || (MediaType = {}));
